import { getAuth, updateProfile } from "firebase/auth";
import { db } from "../firebase";
import {
	updateDoc,
	doc,
	where,
	orderBy,
	getDocs,
	collection,
	query,
	deleteDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MdEditNote } from "react-icons/md";
import PostItem from "../components/PostItem";

export default function Profile() {
	const auth = getAuth();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [post, setPost] = useState(null);
	const [changeDetail, setChangeDetail] = useState(false);
	const [formData, setFormData] = useState({
		name: auth.currentUser.displayName,
		email: auth.currentUser.email,
	});
	const { name, email } = formData;
	function onLogout() {
		auth.signOut();
		navigate("/");
	}
	function onChange(e) {
		setFormData((prevState) => ({
			...prevState,
			[e.target.id]: e.target.value,
		}));
	}
	async function onSubmit() {
		try {
			if (auth.currentUser.displayName !== name) {
				await updateProfile(auth.currentUser, {
					displayName: name,
				});
				const docRef = doc(db, "users", auth.currentUser.uid);
				await updateDoc(docRef, {
					name: name,
				});
			}
			toast.success("Update Successful");
		} catch (error) {
			toast.error("Could not update the profile details");
		}
	}

	useEffect(() => {
		async function fetchUserpost() {
			const postRef = collection(db, "listings");
			const q = query(
				postRef,
				where("userRef", "==", auth.currentUser.uid),
				orderBy("timestamp", "desc")
			);

			const querySnapshot = await getDocs(q);
			const post = [];
			querySnapshot.forEach((doc) => {
				// console.log(doc.id, " => ", doc.data());
				post.push({ id: doc.id, data: doc.data() });
			});
			setPost(post);
			setLoading(false);
		}
		fetchUserpost();
	}, [auth.currentUser.uid]);

	function onEdit(postId, name) {
		navigate(`/edit-post/${postId}`);
	}

	async function onDelete(postId, name) {
		if (window.confirm(`Are you sure want to delete post: ${name}?`)) {
			await deleteDoc(doc(db, "listings", postId));
			const updatedpost = post.filter((post) => postId !== post.id);
			setPost(updatedpost);
			toast.success("Deleted");
		}
	}

	return (
		<>
			<div className="text-2xl font-bold text-gray-200 text-center my-4">
				My Profile
			</div>
			<form className="w-96 text-center mx-auto">
				<input
					className={`w-96 p-2 my-2 rounded-md border ${
						changeDetail && "bg-red-200/10 focus:bg-red-200/10"
					}`}
					value={name}
					id="name"
					disabled={!changeDetail}
					onChange={onChange}
				/>
				<input
					className="w-96 p-2 mb-1 rounded-md border"
					value={email}
					id="email"
					disabled
				/>
			</form>
			<div className="text-sm w-96 flex justify-between mx-auto">
				<p>
					Do you want to change your name?
					<span
						onClick={() => {
							changeDetail && onSubmit();
							setChangeDetail((prevState) => !prevState);
						}}
						className="text-red-500 hover:text-red-600 transition ease-in-out ml-1 cursor-pointer"
					>
						{changeDetail ? "Apply changes" : "Edit"}
					</span>
				</p>
				<p
					onClick={onLogout}
					className="text-blue-500 hover:text-blue-600 transition ease-in-out ml-1 cursor-pointer"
				>
					Sign Out
				</p>
			</div>
			<hr className="mt-6 w-40 mx-auto" />
			<div className="text-center mt-4">
				<Link
					to="/create-post"
					className="inline-block"
				>
					<button
						type="button"
						className="flex mx-auto w-96 my-4 p-2 bg-blue-500 hover:bg-blue-600 text-white items-center justify-center rounded-md shadow-lg hover:shadow-2xl"
					>
						<div>
							<MdEditNote className="text-3xl text-gray-500 bg-white rounded-full p-1" />
						</div>
						<div className="ml-1 text-sm font-semibold uppercase">
							Create a Post
						</div>
					</button>
				</Link>
			</div>
			<div>
				{!loading && post.length > 0 && (
					<>
						<h1 className="text-2xl font-semibold text-center my-4">
							My Posts
						</h1>
						<ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-6xl px-4 py-8 mx-auto">
							{post.map((post) => (
								<PostItem
									post={post.data}
									key={post.id}
									id={post.id}
									onEdit={onEdit}
									onDelete={onDelete}
								/>
							))}
						</ul>
					</>
				)}
			</div>
		</>
	);
}
